export default "__VITE_ASSET__DHS$mjuV__"